// extracted by css-extract-rspack-plugin
export default {"page":"page-mw5I8a","container":"container-kedhCH","title":"title-KxJJK_","panel":"panel-BjxqrR"};